
import * as React from 'react'
import { Provider } from 'react-redux'
import { Store } from 'redux'

import { injectReducers } from './InjectableStore'

type IContextProviderProps = {
  store: Store<any>,
  reducers: any,
}

export class ContextProvider extends React.Component<IContextProviderProps> {
  constructor(props: IContextProviderProps) {
    super(props)

    injectReducers(props.reducers)
  }

  render() {
    const { store } = this.props

    return (
      <Provider store={store}>
        {this.props.children}
      </Provider>
    )
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/core/ContextProvider.tsx